import { Image } from "@mantine/core";
import { useEffect, useState } from "react";

import { itemChangeFile } from "@/api/itemChange/useItemChangeQuery";

type FilePreviewProps = {
  filePath: string | undefined;
};

export const FilePreview = ({ filePath }: FilePreviewProps) => {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    let revokeUrl: string | null = null;
    (async () => {
      try {
        const response = await itemChangeFile.preview(filePath ?? "");
        const blob = response.data;
        const data = await new Response(blob).json();

        const tempUrl = URL.createObjectURL(blob);
        setUrl(data ?? "");
        revokeUrl = tempUrl;
      } catch {
        setUrl(null);
      }
    })();
    return () => {
      if (revokeUrl) URL.revokeObjectURL(revokeUrl);
    };
  }, [filePath]);

  if (!url) return null;
  const fileType = filePath?.split(".").pop()?.toLowerCase();

  if (["png", "jpeg", "jpg"].includes(fileType || "")) {
    return <Image src={url} alt="Uploaded Image" width={200} height={200} />;
  }
  if (fileType === "pdf") {
    return (
      <div style={{ height: "500px", width: "500px" }}>
        <iframe
          src={url}
          width="100%"
          height="100%"
          style={{ border: "none" }}
          title="PDF 미리보기"
        />
      </div>
    );
  }
  return null;
};
